import {
  HttpApiEndpoint,
  HttpApiGroup,
  HttpApiSchema,
  OpenApi,
} from 'effect/unstable/httpapi';
import { OptionalUserAuthMiddleware, UserAuthMiddleware } from './middleware';
import { Schema } from 'effect';
import { GetGetChapterV2200 } from './schemas/audio-dtos';
import { PutUpdateChapterProgressV2Request } from './legacy-client.gen';
import {
  AudioRechunkingError,
  NotFoundError,
  UnauthorizedError,
  InternalServerError,
} from './errors';

const ChapterIdPath = Schema.Struct({
  chapterId: Schema.String.annotate({
    description: 'Chapter ID',
  }),
});

const getChapterEndpoint = HttpApiEndpoint.get('GetChapter', '/:chapterId', {
  params: ChapterIdPath,
  success: GetGetChapterV2200.pipe(HttpApiSchema.status(200)),
  error: [
    NotFoundError,
    UnauthorizedError,
    AudioRechunkingError,
    InternalServerError,
  ],
})
  .middleware(OptionalUserAuthMiddleware)
  .annotate(OpenApi.Summary, 'Get Chapter')
  .annotate(
    OpenApi.Description,
    'Get a single chapter by ID with full paragraph/sentence/word details.',
  );

const updateChapterProgressEndpoint = HttpApiEndpoint.put(
  'UpdateChapterProgress',
  '/:chapterId/progress',
  {
    params: ChapterIdPath,
    payload: Schema.Struct({
      ...PutUpdateChapterProgressV2Request.fields,
      progress_age_ms: Schema.optional(
        Schema.Int.check(Schema.isGreaterThanOrEqualTo(0)),
      ),
    }),
    success: Schema.Void.pipe(HttpApiSchema.status(204)),
    error: [NotFoundError, InternalServerError],
  },
)
  .middleware(UserAuthMiddleware)
  .annotate(OpenApi.Summary, 'Update Chapter Progress')
  .annotate(
    OpenApi.Description,
    "Set the user's current audio position within this chapter (in milliseconds).",
  );

export const chapterGroup = HttpApiGroup.make('Chapter')
  .add(getChapterEndpoint)
  .add(updateChapterProgressEndpoint)
  .prefix('/v2/chapter');
